import { render, staticRenderFns } from "./RslErrorView.vue?vue&type=template&id=65085232&scoped=true&"
var script = {}
import style0 from "./RslErrorView.vue?vue&type=style&index=0&id=65085232&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65085232",
  null
  
)

export default component.exports